<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin"></i> Loading
  </div>
  <div v-else>
    <div class="animated">
      <v-client-table
        :columns="columns"
        :data="managed_lists"
        :options="options"
        :theme="theme"
        id="managed-lists-table"
        class="w-100"
      >
        <span slot="list" slot-scope="{ row }">
          <a :href="'#/managed-lists/' + row.id" class="btn-link">
            {{ row.description }}
          </a>
        </span>
        <span slot="attributes" slot-scope="{ row }">
          {{ row.attribute_lists.length }}
        </span>
      </v-client-table>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable } from "vue-tables-2";
import ManagedListCollection from "@/collections/lab/ManagedListCollection";

Vue.use(ClientTable);

export default {
  name: "ManagedListsTable",
  components: { ClientTable },
  props: {
    show_columns: {
      type: Array,
      default: () => ["list", "attributes"]
    },
    sortable: {
      type: Array,
      default: () => ["list", "attributes"]
    }
  },
  data() {
    return {
      loading: true,
      managed_lists_collection: new ManagedListCollection(),
      managed_lists: null,
      columns: this.show_columns,
      options: {
        headers: {
          list: "List",
          parent: "Parent List",
          attributes: "Attributes"
        },
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        filterable: false
      },
      theme: "bootstrap4",
      template: "default"
    };
  },
  methods: {
    async init() {
      await this.fetch();
    },
    fetch() {
      const fetches = [];

      // we don't want any of the lists that have a parent
      const Filter = this.managed_lists_collection.getFilter();
      Filter.filterNull('parent_id');

      fetches.push(
        this.managed_lists_collection.fetch().then(({ response }) => {
          if (response && response.status === 200 && response.data) {
            this.managed_lists = response.data.data;
          }
        })
      );
      return Promise.all(fetches);
    }
  },
  mounted() {
    this.loading = true;
    this.init().then(() => {
      this.loading = false;
    });
  }
};
</script>
